import type { FC } from 'react';
import React from 'react';
import type { QueryResult } from 'react-apollo';

import { WhiteboardShell } from '@confluence/whiteboard-common/entry-points/whiteboardShell';

import type { SharedContentQuery as SharedContentQueryType } from '../__types__/SharedContentQuery';

type Props = {
	contentId: string;
	shareToken: string;
	sharedContentQuery: QueryResult<SharedContentQueryType, any>;
	isSpaceAliasFFEnabled: boolean;
};

export const WhiteboardExternal: FC<Props> = ({
	contentId,
	shareToken,
	sharedContentQuery,
	isSpaceAliasFFEnabled,
}) => {
	const content = sharedContentQuery.data?.singleContent;

	if (!content || !content.space) {
		return null;
	}

	const { space } = content;
	const spaceAlias = (isSpaceAliasFFEnabled && space.alias) || space.key;

	return (
		<WhiteboardShell
			space={space}
			spaceKey={spaceAlias || ''}
			// operations are only used for "am I readOnly"
			externalShareContent={{ ...content, operations: null }}
			contentId={contentId}
			contentReferenceId={content.referenceId}
			shareToken={shareToken}
			loading={false}
			queryNetworkStatus={sharedContentQuery.networkStatus}
			refetch={sharedContentQuery.refetch}
			allowedFeatures={{
				showMove: false,
				showArchive: false,
				showCopy: false,
				showBreadcrumbs: false,
				showFavourite: false,
				showShare: false,
				showMainActions: true,
				showMoreActions: false,
				showContentRestrictions: false,
				showWatchDialog: false,
			}}
			dataSecurityPolicyPageExport={false}
		/>
	);
};
